import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
}));

const mapContainerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '8px',
    marginBottom: '16px'
};

const defaultCenter = {
    lat: 41.0082,
    lng: 28.9784
};

const LocationSearch = ({ address }) => {
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);

    useEffect(() => {
        if (address && mapLoaded) {
            setLoading(true);
            setError(null);

            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                setLoading(false);
                if (status === 'OK' && results[0]) {
                    const location = results[0].geometry.location;
                    setSelectedLocation({
                        lat: location.lat(),
                        lng: location.lng(),
                        address: results[0].formatted_address
                    });
                } else {
                    setError('Adres bulunamadı');
                    setSelectedLocation(null);
                }
            });
        }
    }, [address, mapLoaded]);

    const onMapLoad = () => {
        setMapLoaded(true);
    };

    return (
        <Box>
            <LoadScript
                googleMapsApiKey="AIzaSyCqXsA57P3W1oWFgktj3VhyvMzAJqenV38"
                libraries={['places']}
            >
                <Box sx={{ height: '400px', width: '100%', mb: 2 }}>
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={selectedLocation || defaultCenter}
                        zoom={selectedLocation ? 15 : 10}
                        onLoad={onMapLoad}
                    >
                        {selectedLocation && (
                            <Marker
                                position={{
                                    lat: selectedLocation.lat,
                                    lng: selectedLocation.lng
                                }}
                            />
                        )}
                    </GoogleMap>
                </Box>
            </LoadScript>

            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                    <CircularProgress />
                </Box>
            )}

            {error && (
                <Typography color="error" sx={{ textAlign: 'center', my: 2 }}>
                    {error}
                </Typography>
            )}

            {selectedLocation && (
                <StyledPaper>
                    <Typography variant="subtitle1" gutterBottom>
                        Seçili Adres:
                    </Typography>
                    <Typography variant="body1">
                        {selectedLocation.address}
                    </Typography>
                </StyledPaper>
            )}
        </Box>
    );
};

export default LocationSearch; 